import React from 'react';

export type LightLayoutContextData = {
  showDrawer: boolean;
  setShowDrawer: React.Dispatch<React.SetStateAction<boolean>>;
  drawerContent: React.ReactNode;
  setDrawerContent: React.Dispatch<React.SetStateAction<React.ReactNode>>;
};

const LightLayoutContext = React.createContext<LightLayoutContextData>({} as LightLayoutContextData);

export const useLightLayoutContext = () => React.useContext(LightLayoutContext);

export const LightLayoutContextProvider: React.FC<LightLayoutContextData> = ({ children, ...value }) => (
  <LightLayoutContext.Provider value={{ ...value }}>
    {children}
  </LightLayoutContext.Provider>
);
